<template>
  <div>
    <b-row>
      <b-col md="4" cols="12">
        <info-card
            label="نوع التبرع"
            :value="getLableType(data.type)"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="مكان ورود التبرع"
          :value="data.place_type === 'freezone' ? 'منطقة حرة':'دولة'"
        />
      </b-col>
      <b-col md="4" cols="12" v-if="data.place_type === 'country'">
        <info-card label="الدولة"
          :value="data.country_id ? data.country_id.name : ''"
        />
      </b-col>
      <b-col md="4" cols="12" v-if="data.place_type === 'freezone'">
        <info-card label="اسم المنطقة الحرة"
          :value="data.free_zone_name"
        />
      </b-col>
      <b-col md="4" cols="12"  v-if="data.place_type === 'country' && data.type !== 'bank_donations'">
        <info-card label="المعبر الحدودي"
          :value="data.border_crossing_id ? data.border_crossing_id.name : ''"
        />
      </b-col>
      <b-col cols="4" v-if='file'>
            <div class="info-card px-2 py-1 my-1">
            <div class="d-flex align-items-center justify-content-between">
                <div>
                ملف محضر الجلسة الإدارية {{ data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label : ''  }} 
                </div>
                <div>
                <b-button
                
                    variant="flat-info"
                    v-b-toggle.doc-view
                    class="btn-icon mx-25"
                    v-b-tooltip.hover.v-info.bottom
                    title="عرض المستند المرفوع"
                    :to="{ name: 'file-view', query: { ep:file  } }"
                >
                    <feather-icon icon="EyeIcon"
                /></b-button>
                </div>
            </div>
            <div>
                <hr />
            </div>
            </div>
        </b-col> 
        
        <b-col md="4" cols="12" v-else>
            <info-card
            label="رقم محضر الجلسة الإدارية"
            :value="data.meeting_minute_id ? data.meeting_minute_id.meeting_minutes_label :''"
            />
        </b-col>

      
    </b-row>
    <b-row v-if="data.type === 'bank_donations'">
      <b-col md="4" cols="12">
        <info-card label="رقم الحساب البنكي"
          :value="data.ngo_bank_account_id ? data.ngo_bank_account_id.account_no :''"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="مبلغ التبرع"
          :value="data.donated_amount"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="العملة المُتبرع بها"
          :value="data.currency_type_id ? data.currency_type_id.name_ar :''"
        />
      </b-col>
    </b-row>
    <b-row  v-if="data.type === 'in_kind_donations'">
      <b-col md="4" cols="12">
        <info-card label="الوصف"
          :value="data.description"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="كمية التبرع"
          :value="data.donated_amount"
        />
      </b-col>
    </b-row>
    <b-row  v-if="data.type === 'machines'">
      <b-col md="4" cols="12">
        <info-card label="نوع المركبة"
          :value="data.machine_type_id ? data.machine_type_id.name_ar : ''"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="الطراز"
          :value="data.model"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="رقم الهيكل"
          :value="data.structure_no"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="رقم المحرك"
          :value="data.engine_number"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="اللون"
          :value="data.color"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="سنة الصنع"
          :value="data.year"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="نوع الوقود"
          :value="data.fuel_type_id ? data.fuel_type_id.name_ar : ''"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="عدد الركاب"
          :value="data.passengers_number"
        />
      </b-col>
      <b-col md="4" cols="12">
        <info-card label="صيغة التملك"
          :value="data.possessive_form_id ? data.possessive_form_id.name_ar : ''"
        />
      </b-col>

      
      <b-col md="4" cols="12">
        <info-card label="معفاة من الضرائب"
          :value="data.tax === 1 ? 'نعم' : 'لا'"
        />
      </b-col>
      
    </b-row>
    <b-row>
      <b-col cols="12" class="mt-2">
        <h5>
          المُرفقات :
        </h5>
      </b-col>
      <b-col cols="4">
        
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              صورة عن الهوية أو جواز سفر المتبرع
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.identification_file } }"
              >
                <feather-icon icon="EyeIcon"
                /></b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>
      <b-col cols="4"   v-if="data.type === 'machines'">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              وثيقة الملكية
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.ownership_doc } }"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>
      
      <!-- <b-col cols="4" v-if="data.type === 'in_kind_donations' && data.invoice_file ">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              الفاتورة
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.invoice_file } }"
              >
                <feather-icon icon="EyeIcon"
                /></b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>

      <b-col cols="4" v-if="data.type === 'in_kind_donations' && data.bill_of_lading_file">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
              بوليصة الشحن الموازنة
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.bill_of_lading_file } }"
              >
                <feather-icon icon="EyeIcon"
                /></b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col> -->

      <b-col cols="4" v-if="data.type === 'in_kind_donations'">
        <div class="info-card px-2 py-1 my-1">
          <div class="d-flex align-items-center justify-content-between">
            <div>
             بيانات التبرع 
            </div>
            <div>
              <b-button

                  variant="flat-info"
                  v-b-toggle.doc-view
                  class="btn-icon mx-25"
                  v-b-tooltip.hover.v-info.bottom
                  title="عرض المستند المرفوع"
                  :to="{ name: 'file-view', query: { ep:data.insurance_file } }"
              >
                <feather-icon icon="EyeIcon"/>
              </b-button>
            </div>
          </div>
          <div>
            <hr />
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
import InfoCard from "@/components/InfoCard.vue";
import axios from "@axios";

import router from "@/router";
export default {
  components: {
    BCard, BImg , BCol , InfoCard , BRow , BButton
  },
  data() {
        return {
            file: '',
        }
    },
  props: {
    data : Object ,
  },
  methods:{
    getLableType(type){
      switch (type){
        case 'bank_donations':
          return 'تبرع مالي'
        case 'in_kind_donations':
          return 'تبرع عيني'
        case 'machines':
          return 'تبرع مركبة'
        default:
          return ''
      }
    }
  },

  directives: {
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
  watch: {
    data: {
        handler: async function(newVal, oldVal) {
            
          const currentRoute = router.currentRoute.path.includes('ministry')
          if(currentRoute){
              console.log("currentRoute" , currentRoute)
              await axios.get(`v2/ministry/ngo-meeting-minutes/${this.data.meeting_minute_id.id}`).then((res) => this.file=res.data.data.file);
          }
          else{
              this.file=null
          }
      },
      deep: true
      }
  },
};
</script>